import "./historyStyle.scss";
import { useEffect, useState } from "react";
import { NavLink, useSearchParams } from "react-router-dom";
import Dashboard from "../../dashboard/Dashboard";
import { Spinner } from "../../../components";
import showToast from "../../../utils/show.toast";
import { HistoryResponse, IHistory } from "../../reviews/types";
import { listPayoutByStatus } from "../../../services/payout.service";
import { ArrowLeft, CheckCheckIcon, CheckIcon, SearchIcon } from "lucide-react";

interface IHistoryData {
  isLoading: boolean;
  history: IHistory[];
}

export default function PayoutHistoryTable() {
  const [historyData, setHistoryData] = useState<IHistoryData>({
    isLoading: true,
    history: [],
  });

  const [SearchParams, setSearchParams] = useSearchParams();
  const withdrawalStatus = SearchParams.get("status");

  const calculatePayoutAmount = (money: string) => {
    // const act = Number(withdrawal) - 8%

    const withdrawalAmount = parseFloat(money);

    if (isNaN(withdrawalAmount) || withdrawalAmount < 0) {
      return "invalid amount";
    }

    const payoutAmount = withdrawalAmount * 0.92;
    return payoutAmount.toFixed(2);
  };

  useEffect(() => {
    if (withdrawalStatus) {
      fetchPaymentHistory(withdrawalStatus);
    }
  }, [withdrawalStatus]);

  const fetchPaymentHistory = async (status: string) => {
    const response = await listPayoutByStatus<HistoryResponse>(
      `withdrawal/?status=${status}`
    );
    if (response.status !== "success") {
      setHistoryData({ history: [], isLoading: false });
      return showToast("Error fetching paided users!", false);
    }

    setHistoryData({ history: response.result, isLoading: false });
  };

  return (
    <Dashboard>
      <div className="history-header">
        <div className="history-title">
          <NavLink to="/payout/dashboard" className="back-link">
            <ArrowLeft className="back-icon" size={20} />
            <span>Payment History</span>
          </NavLink>
        </div>
      </div>

      <div className="history-search">
        <SearchIcon className="search-icon" />
        <input placeholder="Search by Email" />
      </div>

      {historyData.isLoading ? (
        <Spinner />
      ) : (
        <div className="history-table-wrapper">
          <table>
            <thead>
              <tr>
                <th>
                  <CheckCheckIcon />
                </th>
                <th>Name</th>
                <th>Email</th>
                <th>Provider Type</th>
                <th>Withdrawal Amt</th>
                <th>Account Reference</th>
                <th>Payout Amount (USD)</th>
                <th>Request Date</th>
              </tr>
            </thead>
            <tbody>
              {historyData.history.map((pay) => (
                <tr key={pay.teacherProfileId}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>
                    {pay.firstName} {pay.lastName}
                  </td>
                  <td>{pay.email}</td>
                  <td>{pay.paymentMethodType}</td>
                  <td>{pay.amount} USD</td>
                  <td>
                    {pay.paymentMethodType === "paypal"
                      ? pay.paymentDetails.email
                      : pay.paymentDetails.payoneerId}{" "}
                    - {pay.paymentMethodType.toUpperCase()}
                  </td>
                  <td>{calculatePayoutAmount(pay.amount)} USD</td>
                  <td>{new Date(pay.createdAt).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Dashboard>
  );
}
